import React, { useMemo, useState } from 'react';
import { arrayOf, func, number, string } from 'prop-types';
import { LinksContent, ShowMore } from './HotLinks.styles';
import HotLink from '../../atoms/HotLink';

const HotLinks = ({
  items,
  onItemClick,
  directionType,
  limitItems
}) => {
  const [itemsToShow, setItemsToShow] = useState(limitItems);
  const totalItems = items.length;
  const showMore = !!limitItems && itemsToShow < totalItems;
  const visibleItems = useMemo(() => {
    return !limitItems ? items : items.slice(0, itemsToShow);
  }, [limitItems, items, itemsToShow]);

  const renderItems = () => visibleItems.map((item, index) => /*#__PURE__*/React.createElement(HotLink, {
    key: index,
    item: item,
    onClick: onItemClick,
    directionType: directionType,
    borderColor: item.borderColor
  }));

  return /*#__PURE__*/React.createElement(LinksContent, {
    "data-testid": "hot-links",
    directionType: directionType
  }, renderItems(), showMore && /*#__PURE__*/React.createElement(ShowMore, {
    onClick: () => setItemsToShow(totalItems),
    "data-testid": "show-more",
    role: "button"
  }, "Ver mais"));
};

HotLinks.defaultProps = {
  items: [],
  directionType: 'row',
  limitItems: null,
  onItemClick: () => {}
};
process.env.NODE_ENV !== "production" ? HotLinks.propTypes = {
  items: arrayOf(HotLink.propTypes.item),
  onItemClick: func,
  directionType: string,
  limitItems: number
} : void 0;
export default HotLinks;